import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  Typography,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import TrackingDetail from "./TrackingDetail";
import { isMobile } from "react-device-detect";

const TrackingDetailDialog = ({ open, onClose, trackingNumber, hideEditHistory = false }) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullWidth
      maxWidth="md"
      fullScreen={isMobile} // Set fullScreen when isMobile is true
    >
      <DialogTitle>
        <Typography variant="h6" color="secondary">Tracking Details</Typography>
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent align="center" sx={{ padding: 0, margin: 0 }}>
        <TrackingDetail trackingNumber={trackingNumber} hideEditHistory={hideEditHistory} />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="secondary">
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default TrackingDetailDialog;
